import { peopleIncidentEnumsTypeOfIncidentOptionEnum } from '@/gen/types/PeopleIncidentEnumsTypeOfIncidentOption';
import { yesNoOptionEnum } from '@/gen/types/YesNoOption';

import { whenPathEquals } from './conditions';
import type { IncidentFieldRule } from './types';

export const peopleIncidentFieldRules: IncidentFieldRule[] = [
    {
        key: 'subCategory',
        label: 'What was the outcome of the incident?',
        description: 'Select the result of the incident.',
        order: 90,
    },
    {
        key: 'injuredBodyPart',
        label: 'Which part of the body was injured?',
        description: 'Select all body parts that were injured.',
        order: 100,
    },
    {
        key: 'typeOfIncident',
        label: 'What happened?',
        description: 'Select what happened (e.g. fall, electrical contact, manual handling).',
        order: 110,
    },
    {
        key: 'typeOfIncidentExplanation',
        label: 'Type of incident explanation',
        kind: 'textarea',
        order: 120,
        visibleWhen: whenPathEquals('typeOfIncident', peopleIncidentEnumsTypeOfIncidentOptionEnum.Other),
        requiredWhen: whenPathEquals('typeOfIncident', peopleIncidentEnumsTypeOfIncidentOptionEnum.Other),
    },
    {
        key: 'rescueServicesAmbulanceAtScene',
        label: 'Were emergency services or an ambulance involved?',
        description: 'Select Yes if fire brigade, ambulance, or other responders responded.',
        order: 130,
    },
    {
        key: 'authoritiesInvolved',
        label: 'Were authorities involved?',
        description: 'Select Yes if police, labour inspectorate, or other regulators were involved.',
        order: 140,
    },
    {
        key: 'authorityReportingNeeded',
        label: 'Does this need to be reported to authorities?',
        description: 'Select Yes if the incident may require authority notification.',
        order: 150,
    },
    {
        key: 'humanExposureToChemical',
        label: 'Was anyone exposed to chemicals?',
        description: 'Select Yes if anyone had contact with a chemical substance.',
        order: 160,
    },
    {
        key: 'humanExposureToChemicalExplanation',
        label: 'Human exposure explanation',
        kind: 'textarea',
        order: 170,
        visibleWhen: whenPathEquals('humanExposureToChemical', yesNoOptionEnum.Yes),
        requiredWhen: whenPathEquals('humanExposureToChemical', yesNoOptionEnum.Yes),
    },
];
